import { Site } from '@/types/project.types';
import { SiteByProjectIdDto, SiteInfo, SiteListItemDto } from '@/types/site.types';
import { Archive, ArrowRight, Info } from 'lucide-react';

type SiteType = Site | SiteListItemDto | SiteByProjectIdDto | SiteInfo;

const SiteInfoCard = ({
  site,
  handleArrowClick,
  onView,
  onToggleStatus, // new prop
  permissions,
}: {
  site: SiteType;
  handleArrowClick?: (site: SiteType) => void;
  onView?: (site: SiteType) => void;
  onToggleStatus?: (site: any) => void;
  permissions?: Record<string, boolean>;
}) => {
  const handleArrowRightClick = () => {
    handleArrowClick?.(site);
  };

  const handleInfoClick = () => {
    onView?.(site);
  };

  const handleArchiveClick = () => {
    onToggleStatus?.(site); // call parent function to update status
  };

  const isActive = 'status' in site ? Boolean(site.status) : true;

  return (
    <div className="relative flex bg-[#F2EBEE] rounded-lg overflow-hidden capitalize p-3 items-center">
      <div className="relative mr-2 mb-6 flex-shrink-0">
        <div
          className={`w-6 h-6 border ${
            isActive ? 'border-green-400' : 'border-red-400'
          } rounded-full flex items-center justify-center bg-[#F2EBEE]`}
        >
          <div className={`w-4 h-4 ${isActive ? 'bg-green-500' : 'bg-red-500'} rounded-full`} />
        </div>
      </div>

      <div className="flex justify-between items-center w-full">
        <div>
          <p className="font-semibold text-lg flex items-center">{site.name ?? 'Unnamed Site'}</p>
          <p className="text-gray-500 text-base">{'country' in site ? site.country?.name : '--'}</p>
        </div>

        <div className="flex gap-2">
          <button onClick={handleInfoClick}>
            <Info size={20} strokeWidth={1.5} />
          </button>

          <button
            onClick={handleArchiveClick}
            disabled={!permissions?.edit}
            className={`
    transition
    ${!permissions?.edit ? 'opacity-40 cursor-not-allowed' : 'hover:opacity-80'}
  `}
          >
            <Archive size={20} strokeWidth={1.5} />
          </button>

          <button className="cursor-pointer" onClick={handleArrowRightClick}>
            <ArrowRight size={20} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SiteInfoCard;
